import { SecretValue } from './SecretValue';

/** The username and password inside a stored system user secret, when it holds them. */
function readSignIn(raw: string): { user: string | null; pass: string | null } {
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      const user = parsed.username || parsed.user || null;
      const pass = parsed.password || parsed.pass || null;
      return { user: user ? String(user) : null, pass: pass ? String(pass) : null };
    }
  } catch {
    // Not JSON: the whole text is the secret, and it is shown as it is.
  }
  return { user: null, pass: null };
}

interface SystemUserSecretProps {
  /** The secret as it came back from the client's account. */
  raw: string;
}

/**
 * A client's system user sign-in, as it came back from the account. The
 * password starts hidden. Nothing here clears it: it stays until the person
 * leaves the page or asks for another.
 */
export function SystemUserSecret({ raw }: SystemUserSecretProps) {
  const { user, pass } = readSignIn(raw);

  if (!raw) {
    return <p className="secret-value__note">The account returned an empty secret. Check the secret name.</p>;
  }

  return (
    <div>
      {user && <SecretValue label="Username" value={user} />}
      {pass && <SecretValue label="Password" value={pass} secret />}
      {!user && !pass && <SecretValue label="Secret" value={raw} secret />}
      <p className="secret-value__note">
        The password is hidden until you press Show. It stays on this page until you leave it.
      </p>
    </div>
  );
}

export default SystemUserSecret;
